import React, { useState, useEffect } from 'react';
import Ink from 'react-ink';
import PropTypes from 'prop-types';

const RippleButton = ({ type = 'button', onClick, children, className, disabled, style }) => {
  const [key, setKey] = useState(0);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    // Cleanup function to clear the timeout when the component
    // unmounts or before a new timeout is set
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  const handleClick = () => {
    const id = setTimeout(() => {
      setKey(prevKey => prevKey + 1);
    }, 500);

    setTimeoutId(id);
    onClick?.();
  };

  return (
    <button type={type} onClick={handleClick} className={`${className} relative`} disabled={disabled} style={style}>
      {children}
      {!disabled && <Ink key={key} />}
    </button>
  );
};

RippleButton.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default RippleButton;
